"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendLut = exports.getExtendLutInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const hooked_1 = require("../../hooked");
const shared_1 = require("../shared");
function getExtendLutInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.u32)()],
        ['addresses', (0, serializers_1.array)((0, serializers_1.publicKey)(), { size: (0, serializers_1.u64)() })],
    ], { description: 'ExtendLutInstructionData' }), (value) => ({ ...value, discriminator: 2 }));
}
exports.getExtendLutInstructionDataSerializer = getExtendLutInstructionDataSerializer;
// Instruction.
function extendLut(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('splAddressLookupTable', 'AddressLookupTab1e1111111111111111111111111');
    // Accounts.
    const resolvedAccounts = {
        address: { index: 0, isWritable: true, value: input.address ?? null },
        authority: { index: 1, isWritable: false, value: input.authority ?? null },
        payer: { index: 2, isWritable: true, value: input.payer ?? null },
        systemProgram: {
            index: 3,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
    };
    // Arguments.
    const resolvedArgs = { ...input };
    // Default values.
    if (!resolvedAccounts.authority.value) {
        resolvedAccounts.authority.value = context.identity;
    }
    if (!resolvedAccounts.payer.value) {
        resolvedAccounts.payer.value = context.payer;
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'programId', programId);
    // Data.
    const data = getExtendLutInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = (0, hooked_1.resolveExtendLutBytes)(context, resolvedAccounts, resolvedArgs, programId);
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.extendLut = extendLut;
//# sourceMappingURL=extendLut.js.map